export const normalizeCollection = (id = '_id') => (currentValues, originalValues = []) =>
  originalValues.map(originalValue => originalValue?.[id] ?? null)

export const normalizeOne = (id = '_id') => (currentValues, originalValue = {}) =>
  originalValue?.[id] ?? null
